import Handlebars from 'handlebars';

import EventHub from '~/eventHub';
import template from '~/templates/sendpushnotifications.handlebars';
import getNewsService from '~/services/newsService';

import GeneralView from '~/generalView';
import toastr from 'toastr';

var AdminCategoriesView = GeneralView.View.extend({
	tagName: "div",
	className: 'select-category',
	userId: '',
	user: null,
	superCategories: null,
	subCategories: null,
	selectedSuperCategory: '',
	categories: null,
	admincatusers : null,
	qtys: [],
	file: null,
	events: {
		'click #image_alt' : 'activateInput',
		'change #file' : 'uploadImage',
		'click #sendpushnotbtn' : 'sendpushnotifications',
		'click .discardnews' : 'discardfile',
	},
	initialize: function () {
		toastr.options = {
			"closeButton": true,
			"debug": false,
			"newestOnTop": true,
			"progressBar": false,
			"positionClass": "toast-top-center",
			"preventDuplicates": false,
			"onclick": null,
			"showDuration": "300",
			"hideDuration": "1000",
			"timeOut": "5000",
			"extendedTimeOut": "1000",
			"showEasing": "swing",
			"hideEasing": "linear",
			"showMethod": "fadeIn",
			"hideMethod": "fadeOut"
		}
	},
	
	render: function () {
		var handlebarsTemplate = Handlebars.template(template);
		var self = this;
		this.$el.html(handlebarsTemplate());
		this.translate();
		return this;
	},
	
	activateInput: function () {
		$('#file').click();
	},
	
	uploadImage: function (e) {
		var fullPath = $('#file').val();
		var file = $('#file')[0];
		var that = this;
		var reader = new FileReader();
		var namelenght = e.target.files[0].name.length;
		this.filescont++;
		var extension = e.target.files[0].name.substring(namelenght-4, namelenght);
		if (extension.charAt(0) != '.'){
			var extension = e.target.files[0].name.substring(namelenght-5, namelenght);
		}
		var name = 'FileNews_'+this.filescont+extension;
		$('.preview-image').attr('src',window.URL.createObjectURL(file.files[0]));
		$('#file_info').show();
		$('.preview-image').show();
		$('.discardicon').remove();
		$('#file_info').append("<div class='action remove-report discardicon' '  title='Descartar archivo'> <i class='fa fa-trash discardnews'></i></div><br>");
		$(".discardnews").hover(function(){
			$(this).css("color", "#2F4F4F ");
			$(this).css("cursor", "pointer");
		},
		function(){
			$(this).css("color", "inherit");
		});
		reader.onload = function (e) {
			var output = that.getFileStream(e.target.result);
			that.file = new Parse.File(name, output);
		};
		reader.readAsArrayBuffer(e.target.files[0]);
	},
	
	getFileStream: function(file){
		var byteArray = new Uint8Array(file);
		var output = new Array(byteArray.length);
		var i = 0;
		var n = output.length;
		while (i < n) {
			output[i] = byteArray[i];
			i++;
		}
		return output;
	},
	
	discardfile: function(e){
		e.currentTarget.parentElement.remove();
		$('#file').val('');
		$('#file-container').text('');
		$('.preview-image').attr('src', '');
		$('.preview-image').hide();
		$('#file_info').hide();
		this.file = null;
	},
	
	sendpushnotifications: function(){
		var tittle = $('#usr').val();
		var content = $('#comment').val();
		var url = $('#url').val();
		var check;
		if (tittle && content) {
			check = true;
		}
		else{
			check= false;
		}
		if (check ==true) {
			var that = this;
			toastr.options.timeOut = "0";
			toastr.options.extendedTimeOut = "0";
			var txt = '<span>'+ arrlang[lang]["confirmsendpushnot"] +'</span><br><button class="btntoastr btnaccept">'+ arrlang[lang]["ToastrAccept"] +'</button><button class="btntoastr btncancel">'+ arrlang[lang]["ToastrCancel"] +'</button>';
			this.toastrButtons(txt, 'sucess');
			$('.btnaccept').one("click", function(e){
				that.acceptButtonSendPushNot(e);
			});
			$('.btncancel').one("click", function(){
				that.cancelButtonSendPushNot();
			});
		}
		else{
			toastr.error(arrlang[lang]["Errorpushnot"],"Error");
		}
	},
	
	acceptButtonSendPushNot: function(e){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		var tittle = $('#usr').val();
		var content = $('#comment').val();
		var url = $('#url').val();
		var urlTest = url.slice(0, 8);
		if(urlTest != 'https://' && url != ''){
			var urlTest2 = url.slice(0, 7);
			if(urlTest2 != 'http://'){
				url = 'https://' + url;
			}
		}
		var that = this;
		var xl = function(){
			$('#usr').val('');
			$('#comment').val('');
			$('#url').val('');
			$('#file').val('');
			$('#file-container').text('');
			$('.preview-image').attr('src', '');
			$('.discardicon').remove();
			$('.preview-image').hide();
			$('#file_info').hide();
			that.file = null;
			toastr.success(arrlang[lang]["confirmsendpushnotmessage"],"Operación realizada");
		};
		getNewsService().createSimpleFile(tittle, content, url, this.file, Parse.User.current().id, xl);
	},
	
	cancelButtonSendPushNot: function(){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		$('#usr').val('');
		$('#comment').val('');
		$('#url').val('');
		$('#file').val('');
		$('#file-container').text('');
		$('.preview-image').attr('src', '');
		$('.discardicon').remove();
		$('.preview-image').hide();
		$('#file_info').hide();
		this.file = null;
	},
});
export default AdminCategoriesView;
